<div class="avatar"
  class="status-{{stepStatus}}"
  [matTooltip]="statusText">
  <mat-icon>
    @switch (stepStatus) {
      @case (Status.pending) {
        hourglass_empty
      }
      @case (Status.onHold) {
        pause
      }
      @case (Status.inProgress) {
        play_arrow
      }
      @case (Status.done) {
        done
      }
      @case (Status.block) {
        block
      }
      @default {
        question_mark
      }
    }
  </mat-icon>
</div>
